<template>
  <div>
    <div v-for="(item,index) in formList" :key="index">
      <canvas :id="'canvasDom'+ index" class="charts">{{item}}</canvas>
    </div>
  </div>
</template> 
<script>
import uCharts from "@/utils/u-charts.js";
var uChartsInstance = {};
export default {
  data() {
    return {
      categories: ["2018", "2019", "2020", "2021", "2022", "2023"],
      series: [
        {
          name: "目标值",
          data: [35, 36, 31, 33, 13, 34]
        },
        {
          name: "完成量",
          data: [18, 27, 21, 24, 6, 28]
        }
      ], 
      formList: [
        {
          categories: ["2018", "2019", "2020", "2021", "2022", "2023"],
          series: [
            {
              name: "目标值",
              data: [35, 36, 31, 33, 13, 34]
            },
            {
              name: "完成量",
              data: [18, 27, 21, 24, 6, 28]
            }
          ]
        },
        {
          categories: ["2018", "2019", "2020", "2021", "2022", "2023"],
          series: [
            {
              name: "测试",
              data: [35, 36, 31, 33, 13, 34]
            },
            {
              name: "完成量",
              data: [18, 27, 21, 24, 6, 28]
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.formList.map((item, index) => {
      this.showCharts(index, item);
    });
  },
  methods: {
    showArcbar(){

    },
    showCharts(index, item) {
      const canvas = document.getElementById("canvasDom" + index);
      console.log(canvas);
      const ctx = canvas.getContext("2d");
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      uChartsInstance["canvasDom" + index] = new uCharts({
        type: "column",
        context: ctx,
        width: canvas.width,
        height: canvas.height,
        categories: this.categories,
        series: this.series,
        animation: true,
        background: "#FFFFFF",
        color: [
          "#1890FF",
          "#91CB74",
          "#FAC858",
          "#EE6666",
          "#73C0DE",
          "#3CA272",
          "#FC8452",
          "#9A60B4",
          "#ea7ccc"
        ],
        padding: [15, 15, 0, 5],
        enableScroll: false,
        legend: {},
        xAxis: {
          disableGrid: true
        },
        yAxis: {
          data: [
            {
              min: 0
            }
          ]
        },
        extra: {
          column: {
            type: "group",
            width: 30,
            activeBgColor: "#000000",
            activeBgOpacity: 0.08
          }
        }
      });
      canvas.onclick = function(e) {
        uChartsInstance[e.target.id].touchLegend(getH5Offset(e));
        uChartsInstance[e.target.id].showToolTip(getH5Offset(e));
      };
      // canvas.onmousemove = function(e) {
      //   uChartsInstance[e.target.id].showToolTip(getH5Offset(e));
      // };
    }
  }
};
</script>

<style scoped>
.charts {
  width: 500px;
  height: 200px;
  border: solid 1px red;
}
</style>